import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const AddGallery = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]); // For multiple images
  const [singleImage, setSingleImage] = useState(null); // For single image
  const [video, setVideo] = useState(null); // For video
  const [isLoading, setIsLoading] = useState(false);

  // Handle image selection
  const handleImageChange = (e) => {
    setImages([...e.target.files]); // Multiple images
  };

  // Handle single image selection
  const handleSingleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSingleImage(e.target.files[0]);
    }
  };

  // Handle video selection
  const handleVideoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setVideo(e.target.files[0]);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Show SweetAlert confirmation dialog
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You are about to upload the gallery. This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, upload it!",
    });
  
    // If the user confirms, proceed with the upload
    if (result.isConfirmed) {
      setIsLoading(true);
  
      const formData = new FormData();
      formData.append("title", title);
      formData.append("description", description);
  
      // Append multiple images
      images.forEach((image) => {
        formData.append("images", image);
      });
  
      // Append single image
      if (singleImage) {
        formData.append("singleImage", singleImage);
      }
  
      // Append video
      if (video) {
        formData.append("video", video);
      }
  
      try {
        const response = await axios.post(
          "https://server-gs.vercel.app/upload-gallery",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        console.log("Gallery uploaded successfully:", response.data);
        toast.success("Gallery uploaded successfully!");
      } catch (error) {
        console.error("Error uploading gallery:", error);
        toast.error("Gallery upload failed!");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const [isDragging, setIsDragging] = useState(false);
  const [isDraggingImages, setIsDraggingImages] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent propagation to parent elements
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent propagation to parent elements
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent propagation to parent elements
    setIsDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setSingleImage(e.dataTransfer.files[0]);
      e.dataTransfer.clearData(); // Clear data after handling drop
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSingleImage(e.target.files[0]);
    }
  };

  const handleDropImages = (e) => {
    e.preventDefault();
    setIsDraggingImages(false);
    const files = Array.from(e.dataTransfer.files);
    setImages((prevImages) => [...prevImages, ...files]);
  };

  const handleDragOverImages = (e) => {
    e.preventDefault();
    setIsDraggingImages(true);
  };

  const handleDragLeaveImages = () => {
    setIsDraggingImages(false);
  };
  const removeImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const [galleryData, setGalleryData] = useState({
    users: [],
    page: 1,
    totalPages: 1,
    totalDocuments: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://server-gs.vercel.app/all-gallery");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setGalleryData(data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    // Fetch data immediately when the component mounts
    fetchData();

    // Set up an interval to fetch data every second
    const intervalId = setInterval(fetchData, 1000);

    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);


  const handleDelete = async (id) => {
    // Show confirmation dialog
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this item!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });
  
    // If the user confirms, proceed with deletion
    if (result.isConfirmed) {
      try {
        const response = await fetch(`https://server-gs.vercel.app/deleteGallery/${id}`, {
          method: 'DELETE',
        });
  
        if (response.ok) {
          // Remove the deleted item from the state
          setGalleryData((prevData) => ({
            ...prevData,
            users: prevData.users.filter((user) => user._id !== id),
          }));
          Swal.fire('Deleted!', 'Your item has been deleted.', 'success'); // Success message
        } else {
          Swal.fire('Error', 'Failed to delete the item.', 'error'); // Error message
        }
      } catch (error) {
        console.error('Error deleting item:', error);
        Swal.fire('Error', 'An error occurred while deleting the item.', 'error'); // Error message
      }
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="min-h-screen  bg-gray-100">
      <h1 className="text-2xl font-bold text-gray-800 mb-6 bg-white py-6 px-6">Add Gallery</h1>
      <div className="flex flex-row gap-5 w-full p-6">
      <div class="relative overflow-x-auto w-full">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" class="px-6 py-3">
                    Image
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Title
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Posted Date
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Delete
                  </th>
                </tr>
              </thead>
              <tbody>
                {galleryData.users.map((user) => (
                  <tr class="bg-white dark:bg-gray-800">
                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {user.title}
                    </th>
                    <td class="px-6 py-4">
                      <img
                        src={user.singleImage}
                        alt="Single"
                        style={{ width: "100px" }}
                      />
                    </td>
                    <td class="px-6 py-4">
                      {new Date(user.createdAt).toLocaleDateString()}
                    </td>
                    <td class="px-6 py-4"><button  onClick={() => handleDelete(user._id)}>Delete</button> </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        <form onSubmit={handleSubmit} className="w-full bg-white p-5 flex flex-col gap-5">
          {/* Title Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Title
            </label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>

          {/* Description Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Description
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              rows="4"
              required
            />
          </div>

          <div className="space-y-6">
            <div className="flex flex-col">
              <label className="text-lg font-roboto text-gray-700 mb-2">
                Upload Single Image
              </label>
              <div
                className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors ${
                  isDragging ? "border-blue-500 bg-blue-50" : "border-gray-300"
                }`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                {singleImage ? (
                  <div className="flex flex-col items-center">
                    <img
                      src={URL.createObjectURL(singleImage)}
                      alt="Selected"
                      className="w-32 h-32 object-cover mb-4 rounded-lg"
                    />
                    <button
                      type="button"
                      onClick={() => setSingleImage(null)}
                      className="text-sm text-red-600 underline"
                    >
                      Remove Image
                    </button>
                  </div>
                ) : (
                  <p className="text-gray-500">
                    Drag & drop a file here or click to select
                  </p>
                )}
                <input
                  type="file"
                  id="fileInput"
                  className="hidden"
                  onChange={handleFileChange}
                />
                <label
                  htmlFor="fileInput"
                  className="mt-2 inline-block text-blue-600 underline cursor-pointer"
                >
                  Browse File
                </label>
              </div>
            </div>

            <div className="flex flex-col">
              <label className="text-lg font-roboto text-gray-700 mb-2">
                Upload Multiple Images
              </label>
              <div
                className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors ${
                  isDraggingImages
                    ? "border-blue-500 bg-blue-50"
                    : "border-gray-300"
                }`}
                onDragOver={handleDragOverImages}
                onDragLeave={handleDragLeaveImages}
                onDrop={handleDropImages}
              >
                {images.length > 0 ? (
                  <div className="grid grid-cols-3 gap-4">
                    {images.map((image, index) => (
                      <div key={index} className="relative">
                        <img
                          src={URL.createObjectURL(image)}
                          alt={`preview-${index}`}
                          className="w-full h-32 object-cover rounded-lg"
                        />
                        <button
                          type="button"
                          onClick={() => removeImage(index)}
                          className="absolute top-2 right-2 px-2 py-1 bg-red-500 text-white rounded-full "
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray-500">
                    Drag & drop files here or click to select
                  </p>
                )}
                <input
                  type="file"
                  id="fileInputImage"
                  className="hidden"
                  multiple
                  accept="image/*"
                  onChange={handleImageChange}
                />
                <label
                  htmlFor="fileInputImage"
                  className="mt-2 inline-block text-blue-600 underline cursor-pointer"
                >
                  Browse Files
                </label>
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              disabled={isLoading}
            >
              {isLoading ? "Uploading..." : "Upload Gallery"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddGallery;
